"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetWalletTotalQuery = exports.walletApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var statsBaseQuery_1 = require("../../utils/statsBaseQuery");
exports.walletApi = (0, react_1.createApi)({
    reducerPath: "walletApi",
    baseQuery: (0, statsBaseQuery_1.statsBaseQuery)("paymentApi", process.env.STATS_PAYMENT_API, process.env.STATS_PAYMENT_TOKEN),
    tagTypes: ["wallet"],
    endpoints: function (builder) { return ({
        getWalletTotal: builder.query({
            query: function (_a) {
                var region = _a.region;
                return ({ region: region, url: "/v2/retrieve/wallet/totals" });
            },
            transformResponse: function (response, _meta, _a) {
                var _b, _c;
                var currency = _a.currency;
                var match = (_b = response === null || response === void 0 ? void 0 : response.content) === null || _b === void 0 ? void 0 : _b.find(function (c) { return c._id === currency; });
                return (_c = match === null || match === void 0 ? void 0 : match.total) !== null && _c !== void 0 ? _c : 0;
            },
            providesTags: ["wallet"],
        }),
    }); },
});
exports.useGetWalletTotalQuery = exports.walletApi.useGetWalletTotalQuery;
